import React from "react"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

import { Caption } from "@components/type"

const Side = () => (
  <>
    <h3>Math Program Feedback:</h3>
    <StaticQuery
      query={graphql`
        query {
          file(relativePath: { eq: "home/math-program.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 475) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={data => <Img fluid={data.file.childImageSharp.fluid} />}
    />
    <Caption>
      I found the most memorable moment for me was when I was able to explain to
      a student how to perform long division. Hearing the words, "I understand
      it now!" was definitely gratifying for me as a tutor.
    </Caption>
  </>
)

export default Side
